import { AUTOMATION_SERVICES, LICENSE_FEATURES } from '@/config/constants';

const hasDefects = (licenseFeatures: string[] | undefined) =>
  Array.isArray(licenseFeatures) &&
  licenseFeatures.includes(LICENSE_FEATURES.DEFECTS);

const hasManualTestCase = (licenseFeatures: string[] | undefined) =>
  Array.isArray(licenseFeatures) &&
  licenseFeatures.includes(LICENSE_FEATURES.MANUAL_TESTCASES);

const hasWebService = (licenseFeatures: string[] | undefined) =>
  Array.isArray(licenseFeatures) &&
  (licenseFeatures.includes(LICENSE_FEATURES.WEB_SERVICE) ||
    licenseFeatures.includes(LICENSE_FEATURES.ALL));

const hasWeb = (licenseFeatures: string[] | undefined) =>
  Array.isArray(licenseFeatures) &&
  (licenseFeatures.includes(LICENSE_FEATURES.WEB) ||
    licenseFeatures.includes(LICENSE_FEATURES.ALL));

const hasMobile = (licenseFeatures: string[] | undefined) =>
  Array.isArray(licenseFeatures) &&
  (licenseFeatures.includes(LICENSE_FEATURES.MOBILE) ||
    licenseFeatures.includes(LICENSE_FEATURES.ALL));

const hasSalesForce = (licenseFeatures: string[] | undefined) =>
  Array.isArray(licenseFeatures) &&
  (licenseFeatures.includes(LICENSE_FEATURES.SALESFORCE) ||
    licenseFeatures.includes(LICENSE_FEATURES.ALL));

const hasMsDynamics = (licenseFeatures: string[] | undefined) =>
  Array.isArray(licenseFeatures) &&
  (licenseFeatures.includes(LICENSE_FEATURES.MS_DYNAMICS) ||
    licenseFeatures.includes(LICENSE_FEATURES.ALL));

const hasAutomation = (licenseFeatures: string[] | undefined) =>
  Array.isArray(licenseFeatures) &&
  (AUTOMATION_SERVICES.some(service => licenseFeatures.includes(service)) ||
    licenseFeatures.includes(LICENSE_FEATURES.ALL));

window.privilege = {
  hasDefects,
  hasManualTestCase,
  hasWebService,
  hasWeb,
  hasMobile,
  hasSalesForce,
  hasMsDynamics,
  hasAutomation,
};
